"use client";

import catalog from "../../../messages/de/_all";

/** Own JS chunk: browser caches the catalog instead of downloading it inside every HTML. */
export const messages = catalog;

/** Renders nothing. As next/dynamic target, SSR preloads this chunk. */
export function DeCatalogPreload(): null {
  return null;
}
